import { render, staticRenderFns } from "./SideService.vue?vue&type=template&id=a1f3a36e&scoped=true&"
import script from "./SideService.vue?vue&type=script&lang=js&"
export * from "./SideService.vue?vue&type=script&lang=js&"
import style0 from "./SideService.vue?vue&type=style&index=0&id=a1f3a36e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f3a36e",
  null
  
)

export default component.exports